export const SITE_2524_WHATSAPP_URL = 'https://api.cqc.onpromedia.com.br/t/FC401582';

export const resolveSite2524WhatsAppUrl = (site: any, fallbackUrl: string) =>
    Number(site?.id) === 2524 ? SITE_2524_WHATSAPP_URL : fallbackUrl;

// Overrides de URL de WhatsApp por site (rastreamento de cliques). NÃO inclui os
// botões flutuantes nem os cards de corretor — gateados separadamente.
export const SITE_WHATSAPP_URL_OVERRIDES: Record<number, string> = {
    2524: SITE_2524_WHATSAPP_URL,
    // 2451 removido em 18/08 (ticket #1170): cliente deixou o Tintim — links convencionais de volta.
};

export const resolveSiteWhatsAppUrl = (site: any, fallbackUrl: string) =>
    SITE_WHATSAPP_URL_OVERRIDES[Number(site?.id)] ?? fallbackUrl;
